import React from "react";
import { defineMessages } from "react-intl";
import { WideSplitView } from "cci-component";
import { PrimaryPage, ReportPreview } from "cci-admin";
import Options from "../report/expiredInventory/Options";

const messages = defineMessages({
  selectReportOptions: {
    id: "selectReportOptions",
    defaultMessage: "Select the desired options to preview or print the report."
  }
});

/**
 * ExpiredInventory Reports Page.
 */
const ExpiredInventoryReportPage = () => (
  <PrimaryPage>
    <WideSplitView
      rootPath="/expiredinventoryreport"
      selectionPath="/expiredinventoryreport/preview/:options"
      left={Options}
      right={ReportPreview}
      leftRightOptions={{
        reportName: "prs/data/report/expiredInventory.rptdesign"
      }}
      leftOptions={{ previewPath: "/expiredinventoryreport" }}
      placeholderMessage={messages.selectReportOptions}
    />
  </PrimaryPage>
);

export default ExpiredInventoryReportPage;
